<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <p class="copyright">搜搜单词 · 英语单词学习工具</p>
      <p class="links">
        <router-link to="/wordinfo">单词本</router-link>
        <span>|</span>
        <router-link to="/bookword">课本单词</router-link>
        <span>|</span>
        <router-link to="/pictureword">看图记词</router-link>
        <span>|</span>
        <router-link to="/videoword">视频频学</router-link>
      </p>
      <p class="icp">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">
          ICP主体备案号：蜀ICP备2024052991号-1
        </a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MyFooter'
}
</script>

<style scoped>
.site-footer {
  background: #fff;
  border-top: 1px solid #ebeef5;
  padding: 24px 0;
}

.footer-inner {
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
}

.copyright {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
}

.links {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
}

.links a {
  color: #606266;
  margin: 0 6px;
}

.links a:hover {
  color: #409eff;
}

.icp a {
  font-size: 12px;
  color: #c0c4cc;
}

.icp a:hover {
  color: #909399;
}
</style>
